import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["container", "template"];

  connect() {
    // nothing extra needed here
  }

  add(event) {
    event.preventDefault();

    const newId = new Date().getTime().toString();
    // read raw HTML from <template>
    const proto = this.templateTarget.innerHTML;
    const html = proto.replace(/NEW_RECORD/g, newId);

    this.containerTarget.insertAdjacentHTML("beforeend", html);
    // optional: focus first input in newly added item
    const last = this.containerTarget.lastElementChild;
    if (last) {
      const input = last.querySelector("input, textarea");
      if (input) input.focus();
    }
  }

  remove(event) {
    event.preventDefault();

    const item = event.target.closest("[data-itinerary-target='item']");
    if (!item) return;

    const destroyField = item.querySelector("input[name*='_destroy']");
    if (destroyField) {
      // mark for deletion and hide row so nested_attributes will delete it on save
      destroyField.value = "1";
      item.style.display = "none";
    } else {
      // if it wasn't persisted yet just remove it from DOM
      item.remove();
    }
  }
}